import React, { PropTypes } from 'react'
import cx from 'classnames'

import './ProfileInputControl.scss'

const ProfileInputControl = (props) => {
  const {
    className,
    label,
    help,
    children
  } = props

  const componentClassName = cx(
    'ProfileInputControl',
    {
      [className]: className
    }
  )

  return (
    <div className={componentClassName}>
      <div className='ProfileInputControl-label'>
        <label>{label}</label>
      </div>
      <div className='ProfileInputControl-control'>
        <div className='ProfileInputControl-wrapper'>
          {children}
        </div>
        {
          help &&
          <div className='ProfileInputControl-help'>{help}</div>
        }
      </div>
    </div>
  )
}

ProfileInputControl.displayName = 'ProfileInputControl'
ProfileInputControl.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  help: PropTypes.string,
  children: PropTypes.node
}
ProfileInputControl.defaultProps = {}

export default ProfileInputControl



// WEBPACK FOOTER //
// ./src/screens/App/screens/UserProfile/screens/EditProfile/components/ProfileInputControl/ProfileInputControl.js